<div class="modal province-modal">
  <div class="container model-container">
    <div class="modal-header">
     <h4 class="modal-heading" >Select Your Billing Province</h4>
      <img src="assets/icon/primary-close.svg" (click)="closeDialog(false)" class="modal-close" width="28" height="28"
        alt="Close Icon">
    </div>
    <div class="modal-body">
        <div class="modal-content">
            <div class="floating-label">
                <select [(ngModel)]="selectedProvince" class="floating-select" name="provinces" (ngModelChange)="showError = false;">
                <option *ngFor="let province of provinces" [value]="province">
                    {{ province }}
                </option>
                </select>
                <label>Billing Province</label>
            </div>  
            <label class="validation-message" *ngIf="showError">Please Select a Province</label>
            <div class="modal-actions">
                <button class="button primary" (click)="selectProvince()">Proceed</button>
            </div>       
        </div>
    </div>
  </div>
</div>
